import { render, staticRenderFns } from "./EditAllCompanyPaymentPreferenceComponent.vue?vue&type=template&id=32faf423&"
import script from "./EditAllCompanyPaymentPreferenceComponent.vue?vue&type=script&lang=js&"
export * from "./EditAllCompanyPaymentPreferenceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports